export default {"src":"/_next/static/media/fire_40.84b49178.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};